import React from 'react'
import { WidgetBody } from '../../../base'
import { Box, Link, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import AnimatedCheckMark from '../../../base/animated/AnimatedCheckMark/AnimatedCheckMark'
import { toLocalizedNumber } from '../../../utils/helpers'

export interface PaymentSuccessProps {
  paymentAmount: number
  currency: string
  totalAmount: number
  paymentMethodBrand: string
  paymentMethodLast4: string
  paymentId: string
  paymentDescriptor: string
  isCtaVisible: boolean
  contactEmail: string
  ctaLabel: string
  onCtaClick: Function
}

const PaymentSuccess = (props: PaymentSuccessProps) => {
  const theme = useTheme()
  const onCtaClick = () => props.onCtaClick()
  return (
    <WidgetBody
      title='Your payment was submitted'
      subtitle={`Your ${toLocalizedNumber(
        props.paymentAmount,
        props.currency,
      )} payment is processing`}
      ctaLabel={props.isCtaVisible ? props.ctaLabel || 'Continue' : ''}
      onContinue={onCtaClick}
      isHeaderCentered
    >
      <Box
        sx={theme => ({
          display: 'flex',
          justifyContent: 'center',
          marginBottom: theme.spacing(4),
        })}
      >
        <AnimatedCheckMark
          size={102}
          fillColor={theme.palette.primary.main}
          fillLightColor={theme.palette.primary.light}
          fillDarkColor={theme.palette.primary.dark}
          delay={0.4}
        />
      </Box>
      <Typography
        sx={theme => ({
          color: '#000000B2',
          textAlign: 'center',
          fontSize: '0.75em',
          lineHeight: 1.333,
          fontWeight: 600,
          marginBottom: theme.spacing(1),
        })}
      >
        This{' '}
        <strong>{toLocalizedNumber(props.totalAmount, props.currency)}</strong>{' '}
        payment will appear on the statement for your{' '}
        <strong>
          {props.paymentMethodBrand} *{props.paymentMethodLast4}
        </strong>{' '}
        <strong style={{ whiteSpace: 'nowrap' }}>
          {props.paymentDescriptor}
        </strong>
      </Typography>
      <Typography
        sx={{
          color: '#00000080',
          textAlign: 'center',
          fontSize: '0.75em',
          lineHeight: 1.333,
          fontWeight: 400,
        }}
      >
        {props.contactEmail ? (
          <span>
            Contact{' '}
            <Link href={`mailto:${props.contactEmail}`}>
              {props.contactEmail}
            </Link>{' '}
            for questions or concerns and reference this{' '}
          </span>
        ) : (
          ''
        )}
        <span style={{ whiteSpace: 'nowrap' }}>
          payment id: <strong>{props.paymentId}</strong>
        </span>
      </Typography>
    </WidgetBody>
  )
}

export default PaymentSuccess
